module.exports = __webpack_public_path__ + "7704b792526c12fc1b9b26bdbeef857a.png";